// Used to query the URL parameters.

export function useUrlQuery() {
    return new URLSearchParams(window.location.search);
  }
  